/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Embedding_Priority_LabelInputs */



/**
* | output |
* | --- |
* | "Embedding Priority" |
*
* @param {Spaces_Embedding_Priority_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_embedding_priority_label = /** @type {((inputs?: Spaces_Embedding_Priority_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Embedding_Priority_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettungspriorität")
	return /** @type {LocalizedString} */ ("Embedding Priority")
});